export const enum MediaType {
	OctetStream = 'application/octet-stream',
	OctetStream2 = 'binary/octet-stream',

	Html = 'text/html',
	Xhtml = 'application/xhtml+xml',
	Css = 'text/css',

	Woff = 'font/woff',
	Woff2 = 'font/woff2',
	Ttf = 'font/ttf',

	Ico = 'image/vnd.microsoft.icon',
	Png = 'image/png',
	GIF = 'image/gif',
	JPEG = 'image/jpeg',
	Svg = 'image/svg+xml',
	Tiff = 'image/tiff',

	Bmp = 'image/bmp',
	Dib = 'image/x-dib',

	Emf = 'image/emf',
	Emz = 'image/emz',
	Wmf = 'image/wmf',
	Wmz = 'image/wmz',

	Zip = 'application/zip',

	MsWord = 'application/msword',
	MsWordDocOoxml = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	MsWordTemplate = 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
	MsWordDocMacroEnabled = 'application/vnd.ms-word.document.macroEnabled.12',
	MsWordTemplateMacroEnabled = 'application/vnd.ms-word.template.macroEnabled.12',
	Rtf = 'application/rtf',
	Rtfd = 'application/x-rtfd',

	Pdf = 'application/pdf',

	EML = 'message/rfc822',
	EMLX = 'message/x-emlx',
	MSG = 'application/vnd.ms-outlook',

	PST = 'application/vnd.ms-outlook-pst',
	MHTML = 'application/x-mimearchive',
	DXF = 'image/vnd.dxf',
	DWG = 'image/vnd.dwg',
	OLM = 'application/olm',
	Json = 'application/json',

	OLM_EMAIL = 'application/x.ms-outlook-olm-email+xml',
	OLM_APPOINTMENT = 'application/x.ms-outlook-olm-appointment+xml',
	OLM_CONTACT = 'application/x.ms-outlook-olm-contact+xml',
	OLM_NOTE = 'application/x.ms-outlook-olm-note+xml',
	OLM_TASK = 'application/x.ms-outlook-olm-task+xml',

	TGA = 'image/x-tga',

	STEP = 'application/step',
	IGES = 'application/iges',
	PARASOLID_XT = 'model/vnd.parasolid.transmit.text',
	PARASOLID_XB = 'model/vnd.parasolid.transmit.binary',

	ICS = 'text/calendar',
	VCF = 'text/vcard',

	Js = 'text/javascript',

	Xml = 'application/xml',
	Thmx = 'application/vnd.ms-officetheme',

	Pages = 'application/vnd.apple.pages',
	Pages13 = 'application/vnd.apple.pages.13',
	Pages18 = 'application/vnd.apple.pages.18',

	Numbers = 'application/vnd.apple.numbers',
	Numbers13 = 'application/vnd.apple.numbers.13',
	Numbers18 = 'application/vnd.apple.numbers.18',

	Keynote = 'application/vnd.apple.keynote',
	Keynote13 = 'application/vnd.apple.keynote.13',
	Keynote18 = 'application/vnd.apple.keynote.18',

	AppleDouble = 'multipart/appledouble',
	Bplist = 'application/x-bplist',

	Webarchive = 'application/x-webarchive',
	IChat = 'application/x-ichat',

	Ole1 = 'application/x-ms-ole1',
	Ole2 = 'application/x-ms-ole2',

	WordPerfect = 'application/vnd.wordperfect',

	CSV = 'text/csv',
	TSV = 'text/tab-separated-values',
	JBIG2 = 'image/x-jbig2',

	Visio = 'application/vnd.visio',
	SpreadsheetMl = 'application/vnd.ms-spreadsheetml',

	ZipSpanSegment = 'application/x-zip-span-segment',
	ZipSpanSegmentFinal = 'application/x-zip-span-segment-final',

	ZipSplitSegment = 'application/x-zip-split-segment',
	ZipSplitSegmentFinal = 'application/x-zip-split-segment-final',

	OneNote = 'application/msonenote',

	Ichitaro = 'application/x-js-taro',

	PowerPointCfb = 'application/vnd.ms-powerpoint',
	Publisher = 'application/x-mspublisher',

	PGPKey = 'application/pgp-keys',

	PlainText = 'text/plain',

	WebP = 'image/webp',

	PostScript = 'application/postscript',
}
